module.exports = __webpack_public_path__ + "65efe64c1e1f06d4bc69412bc63f3a9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/cpd_cert_ico.svg
// module id = 392
// module chunks = 0